// Origin of a possibly relative url; non-http(s) schemes and invalid urls yield undefined.
export const getAbsoluteUrlOrigin = (url: string): string | undefined => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
      ? parsed.origin
      : undefined;
  } catch {
    return undefined;
  }
};
